export default class DefaultNativeAppInterface {
    emit(e) {
        // eslint-disable-next-line no-console
        console.log(e);
    }
}
